import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { filter, switchMap, tap } from 'rxjs';

import { AuthService } from '@personal-area/global/authorization/services';
import { LoadingState } from '@personal-area/global/state';

import { GetTests } from '../actions/ab-test';
import {
  getABTests,
  getABTestsConfig,
  getABTestsLoadingState,
} from '../selectors/ab-test';

@Injectable({ providedIn: 'root' })
export class ABTestFacade {
  public loadingState$ = this._store.select(getABTestsLoadingState);
  public tests$ = this._store.select(getABTests);
  public config$ = this.loadingState$.pipe(
    tap((state) => {
      // initial state on login, not logout
      if (state === LoadingState.initial && this._authService.isLoggedIn) {
        this.getTests();
      }
    }),
    filter((state) =>
      [LoadingState.loaded, LoadingState.failed].includes(state),
    ),
    switchMap(() => this._store.select(getABTestsConfig)),
  );

  constructor(private _store: Store, private _authService: AuthService) {}

  public getTests(): void {
    this._store.dispatch(GetTests());
  }
}
